/*
 * Copyright (C) 2019 Frontier Developments PLC.
 */

import {Module} from 'vuex';
import {RootState} from '@/store/types';
import {ContentStateInterface} from '@/store/modules/content/types';
import {actions} from '@/store/modules/content/actions';
import {getters} from '@/store/modules/content/getters';
import {mutations} from '@/store/modules/content/mutations';



export const state: ContentStateInterface = {
  blocks: [],
  steps: [],
};

const namespaced: boolean = true;

export const contentStateModule: Module<ContentStateInterface, RootState> = {
  namespaced,
  state,
  actions,
  getters,
  mutations,
};
